import { Instagram, Facebook } from "lucide-react";
import { useSite } from "@/context/SiteContext";

export const XIcon = ({ size = 17 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

export const SocialButtons = ({ className = "" }) => {
  const { site } = useSite();
  const c = site.content;
  const socials = [
    { url: c.social_twitter, icon: XIcon, label: "X (Twitter)", testid: "social-x" },
    { url: c.social_instagram, icon: Instagram, label: "Instagram", testid: "social-instagram" },
    { url: c.social_facebook, icon: Facebook, label: "Facebook", testid: "social-facebook" },
  ].filter((s) => s.url);

  if (socials.length === 0) return null;

  return (
    <div className={`flex gap-3 ${className}`} data-testid="social-links">
      {socials.map((s) => (
        <a
          key={s.label}
          href={s.url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={s.label}
          data-testid={s.testid}
          className="h-10 w-10 rounded-md bg-white/10 flex items-center justify-center hover:bg-[#D97706] transition-colors"
        >
          <s.icon size={17} />
        </a>
      ))}
    </div>
  );
};
